import loadable from '@loadable/component';

export const ViewInvoicePageLoadable = loadable(
  () => import('./ViewInvoicePage'),
  { resolveComponent: (module) => module.ViewInvoicePage },
);
